/**
 * HP Best Sellers — mobile only: hold image for lifestyle preview, tap to PDP.
 * Desktop hover behavior is unchanged (no listeners when viewport is >= 990px).
 */
(function () {
  var HOLD_MS = 400;
  var MOVE_PX = 12;
  var MOBILE_MQ = window.matchMedia('(max-width: 989px)');

  function isMobileHoldEnabled() {
    return MOBILE_MQ.matches;
  }

  function clearHoldState(state) {
    if (!state) return;
    if (state.timer) {
      window.clearTimeout(state.timer);
      state.timer = null;
    }
    if (state.card) {
      state.card.classList.remove('hp-best-sellers__card--mobile-preview');
    }
  }

  function bindMediaLink(link) {
    if (link.getAttribute('data-hp-hold-bound') === 'true') return;
    link.setAttribute('data-hp-hold-bound', 'true');

    var state = null;

    link.addEventListener(
      'touchstart',
      function (e) {
        if (!isMobileHoldEnabled()) return;

        var card = link.closest('.hp-best-sellers__card--has-hover-image');
        if (!card || !card.querySelector('.hp-best-sellers__img--secondary')) return;

        clearHoldState(state);

        var touch = e.touches[0];
        state = {
          card: card,
          startX: touch.clientX,
          startY: touch.clientY,
          held: false,
          suppressClick: false,
          timer: window.setTimeout(function () {
            if (!state) return;
            state.held = true;
            state.suppressClick = true;
            state.card.classList.add('hp-best-sellers__card--mobile-preview');
          }, HOLD_MS)
        };
      },
      { passive: true }
    );

    link.addEventListener(
      'touchmove',
      function (e) {
        if (!state || !state.timer) return;
        var touch = e.touches[0];
        if (
          Math.abs(touch.clientX - state.startX) > MOVE_PX ||
          Math.abs(touch.clientY - state.startY) > MOVE_PX
        ) {
          clearHoldState(state);
          state = null;
        }
      },
      { passive: true }
    );

    function endTouch() {
      if (!state) return;
      if (state.timer) {
        window.clearTimeout(state.timer);
        state.timer = null;
      }
      if (state.held) {
        state.card.classList.remove('hp-best-sellers__card--mobile-preview');
        window.setTimeout(function () {
          if (state) state.suppressClick = false;
        }, 350);
        state.held = false;
        return;
      }
      state = null;
    }

    link.addEventListener('touchend', endTouch, { passive: true });
    link.addEventListener('touchcancel', endTouch, { passive: true });

    link.addEventListener('click', function (e) {
      if (state && state.suppressClick) {
        e.preventDefault();
        e.stopPropagation();
      }
    });
  }

  function init(root) {
    (root || document).querySelectorAll('.hp-best-sellers__media-link').forEach(bindMediaLink);
  }

  if (window.hpBestSellersMobileHoldInit) return;
  window.hpBestSellersMobileHoldInit = true;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();
